import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { tableOpts, hideColumns } from 'Configs/table'
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Label from 'Elements/Label'
import Alert from 'Comps/elements/Alert'
import Table from 'Elements/Table'
import TableNoData from 'Comps/elements/TableNoData'
import { deleteCategory, resetStatusCategory } from 'Reduxes/inventory/configuration/category/categoryActions'
import LoadingContent from 'Elements/LoadingContent';
import { sortSize } from '@/Helper';
import Permission from '../../../../comps/permission/Permission'

const useStyles = makeStyles(theme => ({
    table: {
        '& td:nth-child(2)': {
            width: '10%',
        },
        '& td:nth-child(6)': {
            width: '10%',
        },
        '& .row-action': {
            color: '#555',
            fontSize: '16px',
            marginRight: '8px',
            cursor: 'pointer'
        }
    },
}));

export default function TableData(props) {

    const { setContentActiveFormEdit, deleteCategoryProps, setContentActiveDetail } = props
    const { data, loading, error, success } = useSelector(state => state.categoryReducer);
    const classes = useStyles();
    const dispatch = useDispatch();
    const table = tableOpts({
        data: data?.filter(brand => brand.id > 1),
        colIdPosition: 0,
        filter: false,
        noPrint: true,
        filename: "Category_Configuration_Data",
        table: {
            // options: {
            //     filter: false,
            // },
            columns: [
                // ...hideColumns(['id']),
                {
                    name: 'id',
                    options: {
                        display: false,
                        viewColumns: false
                    }
                },
                {
                    name: 'no',
                    label: 'No.',
                    options: {
                        filter: false,
                        print: true,
                        customBodyRender: (value, tableMeta) => {
                            return tableMeta.rowIndex + 1
                        }
                    }
                },
                { name: "code", label: 'Code' },
                { name: "name", label: 'Category' },
                // {
                //     name: "parent_name", label: 'Parent Category',
                //     options: {
                //         customBodyRender: (value, tableMeta, updateValue) => {
                //             return value ? value : '-'
                //         }
                //     }
                // },
                {
                    name: "status",
                    label: 'Status',
                    options: {
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return (
                                <Label type={value ? 'success' : 'danger'} text={value ? 'active' : 'Inactive'} />
                            )
                        }
                    }
                },
                // {
                //     name: 'category_variant',
                //     label: 'Variant',
                //     options: {
                //         customBodyRender: (value, tableMeta, updateValue) => {
                //             return value && sortSize(value)
                //         }
                //     }
                // },
                {
                    name: "id",
                    label: 'Actions',
                    options: {
                        setCellHeaderProps: () => ({
                            style: {
                                whiteSpace: "nowrap",
                                position: "sticky",
                                right: 0,
                                zIndex: 51
                            }
                        }),
                        setCellProps: () => ({

                            style: {
                                whiteSpace: "nowrap",
                                position: "sticky",
                                right: "0",
                                background: "white",
                                zIndex: 51
                            }
                        }),
                        customBodyRender: (value, tableMeta, updateValue) => {
                            const attrShow = {
                                className: 'row-action',
                                onClick: () => setContentActiveDetail(tableMeta.rowIndex)
                            }
                            const attrEdit = {
                                className: 'row-action',
                                onClick: () => setContentActiveFormEdit(value)
                            }
                            const attrDelete = {
                                className: 'row-action',
                                onClick: () => deleteCategoryProps([value])
                            }

                            return (
                                <>
                                    <VisibilityIcon {...attrShow} />
                                    <Permission
                                        component={
                                            <EditIcon {...attrEdit} />
                                        }
                                        subMenu="category"
                                        type="update"
                                    />
                                    {
                                        value > 1 &&
                                        <Permission
                                            component={
                                                <DeleteIcon {...attrDelete} />
                                            }
                                            subMenu="category"
                                            type="delete"
                                        />
                                    }
                                </>
                            );
                        }
                    }
                },
            ],
        },
        deleteAct: (ids) => {
            dispatch(deleteCategory(ids))
        }
    })


    return (
        <>
            {
                success &&
                <Alert hide={() => dispatch(resetStatusCategory())} option={{ type: 'success', message: success }} />
            }
            {
                error && <Alert hide={() => dispatch(resetStatusCategory())} option={{ type: 'error', message: error }} />
            }
            {
                loading ? <LoadingContent />
                    : (
                        data.length ?
                            <Table {...table} className={classes.table} />
                            : <TableNoData />
                    )
            }
        </>
    )
}

